@if (showBackButton$ | async) {
  <ds-results-back-button [back]="back"></ds-results-back-button>
}
@if (iiifEnabled) {
  <div class="row">
    <div class="col-12">
      <ds-mirador-viewer  id="iiif-viewer"
        [object]="object"
        [searchable]="iiifSearchEnabled"
        [query]="iiifQuery$ | async">
      </ds-mirador-viewer>
    </div>
  </div>
}
<div class="d-flex flex-row">
  <ds-item-page-title-field [item]="object" class="me-auto">
  </ds-item-page-title-field>
  <ds-context-menu [contextMenuObject]="object" [contextMenuObjectType]="$any('ITEM')"></ds-context-menu>
</div>
<div class="row">
  <div class="col-12 col-md-4">
    @if (!(mediaViewer.image || mediaViewer.video)) {
      <ds-metadata-field-wrapper [hideIfNoTextContent]="false">
        <ds-thumbnail [thumbnail]="object?.thumbnail | async"></ds-thumbnail>
      </ds-metadata-field-wrapper>
    }
    @if (mediaViewer.image || mediaViewer.video) {
      <div class="mb-2">
        <ds-media-viewer [item]="object"></ds-media-viewer>
      </div>
    }
    <ds-item-page-file-section [item]="object"></ds-item-page-file-section>
    <ds-item-page-date-field [item]="object"></ds-item-page-date-field>
    <ds-metadata-representation-list class="ds-item-page-mixed-author-field"
      [parentItem]="object"
      [itemType]="'Person'"
      [metadataFields]="['dc.contributor.author', 'dc.creator']"
      [label]="'item.page.authors' | translate">
    </ds-metadata-representation-list>
    <ds-generic-item-page-field [item]="object"
      [fields]="['journal.title']"
      [label]="'publication.page.journal-title'">
    </ds-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
      [fields]="['journal.identifier.issn']"
      [label]="'publication.page.journal-issn'">
    </ds-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
      [fields]="['journalvolume.identifier.name']"
      [label]="'publication.page.volume-title'">
    </ds-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.publisher']"
      [label]="'publication.page.publisher'">
    </ds-generic-item-page-field>
  </div>
  <div class="col-12 col-md-7">
    <ds-related-items
      [parentItem]="object"
      [relationType]="'isProjectOfPublication'"
      [label]="'item.page.projects' | translate">
    </ds-related-items>
    <ds-related-items
      [parentItem]="object"
      [relationType]="'isOrgUnitOfPublication'"
      [label]="'item.page.org-units' | translate">
    </ds-related-items>
    <ds-related-items
      [parentItem]="object"
      [relationType]="'isJournalIssueOfPublication'"
      [label]="'item.page.journal-issue' | translate">
    </ds-related-items>
    <ds-item-page-abstract-field [item]="object"></ds-item-page-abstract-field>
    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.description']"
      [label]="'publication.page.description'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.subject']"
      [separator]="', '"
      [label]="'item.page.subject'">
    </ds-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
      [fields]="['dc.identifier.citation']"
      [label]="'item.page.citation'">
    </ds-generic-item-page-field>
    <ds-item-page-uri-field [item]="object"
      [fields]="['dc.identifier.uri']"
      [label]="'item.page.uri'">
    </ds-item-page-uri-field>
    <ds-item-page-collections [item]="object"></ds-item-page-collections>
    <ds-item-page-uri-field [item]="object"
      [fields]="['coar.notify.endorsedBy']"
      [label]="'item.page.endorsement'">
    </ds-item-page-uri-field>
    <ds-item-page-uri-field [item]="object"
      [fields]="['datacite.relation.isReviewedBy']"
      [label]="'item.page.review'">
    </ds-item-page-uri-field>
    <ds-item-page-uri-field [item]="object"
      [fields]="['datacite.relation.isSupplementedBy']"
      [label]="'item.page.supplemented'">
    </ds-item-page-uri-field>
    <ds-item-page-uri-field [item]="object"
      [fields]="['datacite.relation.isReferencedBy']"
      [label]="'item.page.referenced'">
    </ds-item-page-uri-field>
    @if (geospatialItemPageFieldsEnabled) {
      <ds-geospatial-item-page-field [item]="object"
                                     [label]="'item.page.places'"
                                     [pointFields]="['dcterms.spatial']"
                                     [bboxFields]="['dcterms.spatial']"
                                     [cluster]="true"
      >
      </ds-geospatial-item-page-field>
    }
    <div>
      <a class="btn btn-outline-primary" role="button" [routerLink]="[itemPageRoute + '/full']" role="button" tabindex="0">
        <i class="fas fa-info-circle"></i> {{"item.page.link.full" | translate}}
      </a>
    </div>
  </div>
</div>
